@if (gdShowFlag) {
  <div id="{{gdFieldId}}Question"
    [ngClass]="gdAddClass" class="febi-tag enable-pointer-events {{gdDisableHook}}">
    @if (gdShowLabel) {
      <label [attr.for]="gdFieldId" id="{{gdFieldId}}GroupLabel" [ngClass]="gdHideLabel" [innerHTML]="gdLabel"></label>
    }
    <div class="inputBlock">
      <div class="select">
        <select name="{{gdFieldId}}" id="{{gdFieldId}}" class="" [ngClass]="{'select-nextgen': gdStyleNextGen}" [(ngModel)]="gdModel" [disabled]="gdDisabled"
          (ngModelChange)="outputGdModel()"
          (keydown.Tab)="onTab()" [attr.aria-labelledby]="ariaLabelledby"
          (focus)="onFocus()"
          autocomplete="off">
          @for (option of gdOptions; track option) {
            <option
              [attr.disabled]="option.disabled ? '' : null"
              [attr.hidden]="option.hidden ? '' : null"
            value="{{option.value}}">{{option.display}}</option>
          }
        </select>
      </div>
    </div>
  </div>
}